import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  height: "80",
  viewBox: "0 0 64 80",
  width: "64",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m60 0h-56c-2.20914 0-4 1.79086-4 4v72c0 2.2091 1.79086 4 4 4h41l19-19v-57c0-2.20914-1.7909-4-4-4z",
      fill: "#fff"
    }, null, -1),
    _createElementVNode("path", {
      d: "m64 61h-19v19z",
      fill: "#838383",
      opacity: ".5"
    }, null, -1),
    _createElementVNode("path", {
      d: "m40.9418 21.0335-15.3382 4.0921c-.5814.156-1.0581.8068-1.0581 1.4471v17.7657c0 .5344-.3404.9989-.8259 1.1293l-4.0691 1.0862c-.9698.2584-1.6505 1.1886-1.6505 2.255v.6997c0 2.2702 1.9996 3.9361 4.0636 3.3855l2.1884-.5845c1.4542-.3865 2.4753-1.7823 2.4753-3.3819v-15.0787c0-.6403.4767-1.2911 1.0582-1.4471l10.9745-2.928c.5815-.1548 1.0582.2422 1.0582.8825v9.9073c0 .5344-.3404.9989-.8258 1.1293l-4.0691 1.0862c-.9698.2584-1.6506 1.1886-1.6506 2.255v.6997c0 2.2702 1.9997 3.9362 4.0637 3.3855l2.1883-.5844c1.4542-.3866 2.4753-1.7824 2.4753-3.382v-13.5757-9.3613c0-.6404-.4767-1.0373-1.0582-.8825z",
      fill: "#ababab"
    }, null, -1)
  ]))]))
}
export default { render: render }